module.exports = __webpack_public_path__ + "static/media/atacado_fundo_cinza_large.984c6841.png";